<template>
    <modal :show="show" class="white-content" @update:show="$emit('update:show', $event)">
      <h3 class="card-title">{{ $t('tools.updateReservation') }}</h3>
      <div class="row">
        <div class="row">
          <label class="col-md-12 col-form-label">{{ $t('tools.totalCount') }} *</label>
          <div class="col-8" style="padding-right:0px">
            <material-input
              id="updatedUnit"
              v-model:value="unitString"
              :placeholder="`${$t('tools.totalCount')} ${initialPriceTypeLabel}*`"
            />
          </div>
          <div class="col-4" style="padding-left:0px">
            <material-input
              id="initialPriceTypeLabel"
              :placeholder="initialPriceTypeLabel"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-end">
          <material-button type="standard" fill @click="$emit('submit')">{{ $t('common.submit') }}</material-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import Modal from './Modal.vue';
  import MaterialInput from '../MaterialInput.vue';
  import MaterialButton from '../MaterialButton.vue';
  
  export default {
    components: { Modal, MaterialInput, MaterialButton },
    props: {
      show: { type: Boolean, required: true },
      updatedUnit: { type: Number, default: null },
      initialPriceTypeLabel: { type: String, required: true }
    },
    emits: ['update:show', 'update:updatedUnit', 'submit'],
    data() {
      return {
        localUpdatedUnit: this.updatedUnit
      };
    },
    watch: {
      show(newVal) {
        if (newVal) {
          this.localUpdatedUnit = this.updatedUnit;
        }
      }
    },
    computed: {
      unitString: {
        get() {
          return this.localUpdatedUnit !== null ? this.localUpdatedUnit.toString() : '';
        },
        set(val) {
          this.localUpdatedUnit = val ? Number(val) : null;
          this.$emit('update:updatedUnit', this.localUpdatedUnit);
        }
      }
    }
  };
  </script>